import { resolveTreatments, resolveTreatment } from './resolvers/treatments.resolver';
import { resolveNestedCategories } from '../event/resolvers/categories.resolver';

export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.admin.treatments', {
            url: '/events/treatments?:filtertext',
            component: 'treatmentList',
            resolve: {
                treatments: resolveTreatments(),
                categories: resolveNestedCategories('flatten')
            },
            roles: ['manager']
        })
        .state('app.admin.deletedtreatments', {
            url: '/events/treatments/deleted',
            component: 'treatmentList',
            resolve: {
                treatments: resolveTreatments(1, 20, 'deleted')
            },
            roles: ['admin']
        })
        .state('app.admin.treatment-add', {
            url: '/events/treatments/create',
            component: 'treatmentSave',
            resolve: {
                title: () => 'Create a Treatment',
                treatment: resolveTreatment()
            },
            roles: ['manager']
        })
        .state('app.admin.treatment-edit', {
            url: '/events/treatments/:treatment/update?tab',
            component: 'treatmentSave',
            resolve: {
                title: () => 'Update a Treatment',
                treatment: resolveTreatment()
            },
            roles: ['manager']
        });
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/treatment.routes.js